<div class="content-box principal-content container">
    <p class="principal-title">{{ 'stt.faq.title' | translate }}</p>

    <div class="row">
        <button mat-button class="btn-back" mat-raised-button (click)="volverHome()">
            <mat-icon aria-hidden="false" aria-label="keyboard_backspace">keyboard_backspace</mat-icon>
            {{ 'stt.boton.back' | translate }}
        </button>
    </div>
    
    <mat-expansion-panel>
        <mat-expansion-panel-header>
            <div class="subtitleques">1.- {{ 'stt.faq.q1' | translate }}</div>
        </mat-expansion-panel-header>      
        <ng-template matExpansionPanelContent> 
             <p class="textques">{{'stt.faq.r1.0' | translate }}</p>
             <img class="imagen"  src="../../../assets/img/question1.1.png">
             <p class="imagentext">{{ 'stt.faq.i1.0' | translate }}</p>
             <br>            
             <p class="textques">{{'stt.faq.r1.1' | translate }}</p>
            <img class="imagen" src="../../../assets/img/question1.2.png">
            <p class="imagentext">{{ 'stt.faq.i1.1' | translate }}</p>
            <br> 
            <p class="textques">{{ 'stt.faq.r1.2' | translate }}</p>
            <img class="imagen" src="../../../assets/img/question1.3.png">
            <p class="imagentext">{{ 'stt.faq.i1.2' | translate }}</p>
            <br> 
            <p class="textques">{{ 'stt.faq.r1.3' | translate }}</p>
            <img class="imagen" src="../../../assets/img/question1.4.png">
            <p class="imagentext">{{ 'stt.faq.i1.3' | translate }}</p>
        </ng-template>
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
            <div class="subtitleques">2.- {{ 'stt.faq.q2' | translate }}</div>
        </mat-expansion-panel-header>      
        <ng-template matExpansionPanelContent>            
            <p class="textques">{{ 'stt.faq.r2.0' | translate }}</p>
            <img class="imagen" src="../../../assets/img/question2.0.png">
            <p class="imagentext">{{ 'stt.faq.i2.0' | translate }}</p>
        </ng-template>
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
            <div class="subtitleques">3.- {{ 'stt.faq.q3' | translate }}</div>
        </mat-expansion-panel-header>      
        <ng-template matExpansionPanelContent>            
            <p class="textques">{{ 'stt.faq.r3.0' | translate }}</p>
            <img class="imagen" src="../../../assets/img/question3.0.png">
            <p class="imagentext">{{ 'stt.faq.i3.0' | translate }}</p>
        </ng-template>
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
            <div class="subtitleques">4.- {{ 'stt.faq.q4' | translate }}</div>
        </mat-expansion-panel-header>      
        <ng-template matExpansionPanelContent>            
            <p class="textques">{{ 'stt.faq.r4.0' | translate }}</p><br>
            <img class="imagen" src="../../../assets/img/question4.0.png">
            <p class="textques">{{ 'stt.faq.r4.1' | translate }}</p>
            <img class="imagen" src="../../../assets/img/question4.1.png">
            <p class="textques">{{ 'stt.faq.r4.2' | translate }}</p>
            <p class="imagentext">{{ 'stt.faq.i4.0' | translate }}</p>
        </ng-template>
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
            <div class="subtitleques">5.- {{ 'stt.faq.q5' | translate }}</div>
        </mat-expansion-panel-header>      
        <ng-template matExpansionPanelContent>            
            <p class="textques">{{ 'stt.faq.r5.0' | translate }}</p>
            <img class="imagen" src="../../../assets/img/question5.0.png">
            <p class="imagentext">{{ 'stt.faq.i5.0' | translate }}</p>
        </ng-template>
      </mat-expansion-panel>   
      <mat-expansion-panel>
        <mat-expansion-panel-header>
            <div class="subtitleques">6.- {{ 'stt.faq.q6' | translate }}</div>
        </mat-expansion-panel-header>      
        <ng-template matExpansionPanelContent>            
            <p class="textques">{{ 'stt.faq.r6.1' | translate }}</p>
            <img class="imagen" src="../../../assets/img/question6.0.png">
            <p class="imagentext">{{ 'stt.faq.i6.0' | translate }}</p>
        </ng-template>
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
            <div class="subtitleques">7.- {{ 'stt.faq.q7' | translate }}</div>
        </mat-expansion-panel-header>      
        <ng-template matExpansionPanelContent>            
            <p class="textques">{{ 'stt.faq.r7.1' | translate }}</p>
            <img class="imagen" src="../../../assets/img/question7.0.png">
            <p class="imagentext">{{ 'stt.faq.i7.0' | translate }}</p>
            <p class="textques">{{ 'stt.faq.r7.2' | translate }}</p>
            <img class="imagen" src="../../../assets/img/question7.1.png">
            <p class="imagentext">{{ 'stt.faq.i7.1' | translate }}</p>
            <p class="textques">{{ 'stt.faq.r7.3' | translate }}</p>
            <img class="imagen" src="../../../assets/img/question7.2.png">
            <p class="imagentext">{{ 'stt.faq.i7.2' | translate }}</p>
        </ng-template>
      </mat-expansion-panel>
</div>